export default __webpack_public_path__ + "static/media/PNSC.110af066.png";